module.exports = __webpack_public_path__ + "static/media/proceso-02-recolectamos.5b6118d3.svg";